<template>
	<div class="view-wrapper">
		<div 	class="view-container"
				v-if="text !== null && error == null">
			<b-container class="no-padding">
				<b-row>
					<b-col>
						<p><h3 class="vrnu-headline">{{ text.ident }}</h3></p>
						<b-container style="padding: 20px; border: 2px dotted #343a40;">
							<b-row>
								<b-col>
									<h4 class="text-underlined">{{ text.headline }}</h4>
									<span>{{ text.email }}</span>
                  <p v-html="text.text"></p>
								</b-col>
							</b-row>
						</b-container>
					</b-col>
				</b-row>
			</b-container>
		</div>
		<div v-else>
			<b-alert show variant="danger">{{ error }}</b-alert>
		</div>
	</div>
</template>

<script>
export default {
	data: function() {
		return {
			text: null,
			error: null,
		};
	},
	methods: {
		getText: function() {
			// Save the text
			this.$http.get('texts/' + this.objectId).then(result => {
				this.text = result.body;
			}, response => {
				this.error = "Beim Laden des Texts ist ein Fehler aufgetreten. Bitte wenden Sie sich an den Systemadministrator!";
			});
		},
		closeModal: function() {
			this.$emit('closeModal');
		},
	},
	mounted: function() {
		// Load text from database
		this.getText();
	},
	props: {
		objectId: {
			required: true,
		}
	},
}
</script>

<style>
.form-container {
	padding: 5px;
}
.text-underlined {
	text-decoration: underline;
}
.icon-large {
	font-size: 8rem;
}
</style>



// WEBPACK FOOTER //
// src/components/11_text/TextsView.vue